import { createRouter, type AnyRouter } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";
import { useNavigationHistoryStore } from "@/store/navigation-history-store";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
});

export function registerNavigationHistorySubscription(
  targetRouter: AnyRouter,
): () => void {
  return targetRouter.subscribe(
    "onBeforeLoad",
    ({ fromLocation, toLocation, pathChanged }) => {
      if (pathChanged) {
        useNavigationHistoryStore
          .getState()
          .recordNavigation(
            fromLocation?.pathname ?? null,
            toLocation.pathname,
          );
      }
    },
  );
}

registerNavigationHistorySubscription(router);

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    breadcrumb?: string;
  }
}
